import type { IDropdownOption } from '@frontend/pole-ui/lib/components/Dropdown'
import type { CallbackRequest } from '@pole-api/lib-ifa-communication-api/lib/models/CallbackRequest'
import { formatLocalizedString } from '@/utils/formatUtils'
import { TIMES } from './constants'
import { messages } from './messages'
import type { IFinancingCallbackForm } from './types'

export const getRequestBodyForCallbackRequest = (formValue: IFinancingCallbackForm, contextOfRequest: string): CallbackRequest => {
  return { name: formValue.name, phone: formValue.phone, date: formValue.date, time: formValue.time, comment: contextOfRequest }
}

export const getDateOptions = (): IDropdownOption[] => {
  const result: IDropdownOption[] = []

  const DAYS_OF_WEEK = [
    messages.form.daysOfWeek.sunday,
    messages.form.daysOfWeek.monday,
    messages.form.daysOfWeek.tuesday,
    messages.form.daysOfWeek.wednesday,
    messages.form.daysOfWeek.thursday,
    messages.form.daysOfWeek.friday,
    messages.form.daysOfWeek.saturday,
  ]
  const COUNT_OF_DAYS = 3

  const today = new Date()
  let added = 0
  let offset = 0

  while (added < COUNT_OF_DAYS) {
    const date = new Date(today)
    date.setDate(today.getDate() + offset)
    const dayOfWeek = date.getDay()

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      const formattedDate = `${day}.${month}.${year}`

      let label = ''

      if (added === 0 && offset === 0) {
        label = formatLocalizedString(messages.form.date.value, { date: formattedDate })
      } else {
        label = `${DAYS_OF_WEEK[dayOfWeek]} (${formattedDate})`
      }

      result.push({ value: formattedDate, label })

      added += 1
    }

    offset += 1
  }

  return result
}

export const getTimeIntervals = (): IDropdownOption[] => {
  return TIMES.map(time => ({ value: time, label: time }))
}
